export enum FeatureFlag {
  Shop = 'NX_FF_SHOP',
  Shop_Checkout = 'NX_FF_SHOP_CHECKOUT',
  Cancel_Appointments = 'NX_FF_CANCEL_APPOINTMENTS',
  BookingAllowed = 'NX_BOOKING_ALLOWED',
  Raffles = 'NX_FF_RAFFLES',
  BannerTelegramChannel = 'NX_FF_BANNER_TELEGRAM_CHANNEL',
  BannerInstagramChannel = 'NX_FF_BANNER_INSTAGRAM_CHANNEL',
  BdmNotifications = 'NX_FF_BDM_NOTIFICATIONS',
  BdmOutcomeDetection = 'NX_FF_BDM_OUTCOME_DETECTION',
  Bdm2FilloutDetection = 'NX_FF_BDM2_FILLOUT_DETECTION',
  BdmExclusion = 'NX_FF_BDM_EXCLUSION',
}
